<template>
  <div>
    <LiquidacionReportesFiltersPanel
      :filters.sync="filters"
      report-type="resumen"
      :perfil="perfil"
      :loading="loading"
      :exporting="exporting"
      @clear="resetFilters"
      @export="exportReport"
    />

    <LiquidacionReportesTable
      :items="items"
      :fields="tableFields"
      :money-columns="moneyColumns"
      show-penalidad-tooltip
      :section-title="messages.RESUMEN_SECTION_TITLE"
      :empty-text="messages.EMPTY_TABLE"
      :loading-text="messages.LOADING"
      :loading="loading"
      :load-error="loadError"
      :current-page.sync="currentPage"
      :per-page="perPage"
      :total-rows="totalRows"
    />
  </div>
</template>

<script>
import LiquidacionReportesFiltersPanel from "./LiquidacionReportesFiltersPanel.vue";
import LiquidacionReportesTable from "./LiquidacionReportesTable.vue";
import {
  exportLiquidacionResumen,
  fetchLiquidacionResumen,
  getLiquidacionReportesErrorMessage,
} from "@/services/liquidacion-reportes/liquidacion-reportes.api";
import {
  getDefaultFiltroLiquidacion,
  resolveLiquidacionReportTipo,
} from "@/services/liquidacion-reportes/liquidacion-reportes.contract";
import {
  MESSAGES,
  RESUMEN_DEFAULT_PER_PAGE,
  RESUMEN_MONEY_COLUMNS,
  getResumenTableFields,
} from "@/services/liquidacion-reportes/liquidacion-reportes.constants";
import { isProveedor } from "@/constants/perfiles";
import { mapState } from "vuex";

export default {
  name: "LiquidacionResumenTab",

  components: {
    LiquidacionReportesFiltersPanel,
    LiquidacionReportesTable,
  },

  data() {
    return {
      messages: MESSAGES,
      moneyColumns: RESUMEN_MONEY_COLUMNS,
      filters: getDefaultFiltroLiquidacion(),
      items: [],
      totalRows: 0,
      loading: false,
      exporting: false,
      loadError: "",
      currentPage: 1,
      perPage: RESUMEN_DEFAULT_PER_PAGE,
      filterDebounceTimer: null,
    };
  },

  computed: {
    ...mapState("module", ["perfil", "idProvider"]),
    tableFields() {
      return getResumenTableFields(isProveedor(this.perfil));
    },
    reportOptions() {
      const options = { tipo: resolveLiquidacionReportTipo(this.perfil) };

      if (isProveedor(this.perfil) && Number(this.idProvider) > 0) {
        options.idProv = Number(this.idProvider);
      }

      return options;
    },
  },

  watch: {
    filters: {
      deep: true,
      handler() {
        clearTimeout(this.filterDebounceTimer);
        this.filterDebounceTimer = setTimeout(() => {
          if (this.currentPage !== 1) {
            this.currentPage = 1;
          } else {
            this.loadReport();
          }
        }, 300);
      },
    },
    currentPage() {
      this.loadReport();
    },
  },

  created() {
    this.loadReport();
  },

  beforeDestroy() {
    clearTimeout(this.filterDebounceTimer);
  },

  methods: {
    async loadReport() {
      this.loading = true;
      this.loadError = "";

      try {
        const result = await fetchLiquidacionResumen(
          this.filters,
          { page: this.currentPage, limit: this.perPage },
          this.reportOptions,
        );
        this.items = result.items;
        this.totalRows = result.total;
      } catch (error) {
        this.items = [];
        this.totalRows = 0;
        this.loadError = getLiquidacionReportesErrorMessage(error);
      } finally {
        this.loading = false;
      }
    },

    resetFilters() {
      this.filters = getDefaultFiltroLiquidacion();
    },

    async exportReport() {
      this.exporting = true;

      try {
        await exportLiquidacionResumen(this.filters, this.reportOptions);
        this.$bvToast.toast(this.messages.EXPORT_SUCCESS, {
          title: "Exportar",
          variant: "success",
          solid: true,
          autoHideDelay: 4000,
        });
      } catch (error) {
        this.$bvToast.toast(
          getLiquidacionReportesErrorMessage(error) || this.messages.EXPORT_ERROR,
          {
            title: "Exportar",
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          },
        );
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>
